import { createFileRoute, redirect } from '@tanstack/react-router';
import { REGISTRATION_PROFILE_BASE_PATH } from '../../../../features/registration/profile/registration-profile-routing';

export const Route = createFileRoute('/_app/_clearing-core/registration/')({
  beforeLoad: () => {
    throw redirect({ to: REGISTRATION_PROFILE_BASE_PATH });
  },
  preload: false,
});
